import { log } from '@/log'
import { LoadSessionData } from './load-session-data'

export class SessionDataService {
  static async userIsRegistered(fallback: boolean = false): Promise<boolean> {
    return LoadSessionData.getInstance().load().then(
      payload => payload.data.isRegistered,
      (e) => {
        log.error('cannot determine user is registered or not', e)

        return fallback
      }
    )
  }
}
